export const CAROUSEL_TYPES = {
    PROPERTY: 'property_carousel',
    DESTINATION: 'destination_carousel',
};

export const EVENT_TYPES = {
    PRESENTED: 'presented',
    SELECTED: 'selected',
    UPDATED: 'updated',
};

export const CAROUSEL_HIT_ID_PATH = {
    [CAROUSEL_TYPES.PROPERTY]: 'listing.listingId',
    [CAROUSEL_TYPES.DESTINATION]: 'searchTermUuid',
};

export const EDAP_EVENT_DATA_FIELDS = {
    ACTIONLOCATION: 'actionlocation', // client target
    CARD_INDEX: 'card_index', // index of a card being clicked
    CAROUSEL_CHILD: 'carousel_child', // property triad or destination uuid of selected card
    CAROUSEL_TITLE: 'carousel_title',
    // triads/uuids of cards in view after updating the carousel by swiping/clicking on arrows
    CHILDREN_DISPLAYED: 'children_displayed',
    CHILDREN_DISPLAYED_ATTRIBUTES: 'children_displayed_attributes', // displayed attributes of cards on view / JSON
    RECOMMENDATION_REQUEST_MARKER: 'recommendation_request_marker', // clientRequestId field from GraphQL
};

export const CAROUSEL_DATA_FIELDS = {
    TARGET: 'target',
    TITLE: 'title',
    HITS_IN_VIEW: 'hitsInView',
    HITS_IN_VIEW_IDS: 'hitsInViewIds',
    CLIENT_REQUEST_ID: 'clientRequestId',
    CARD_INDEX: 'cardIndex',
    CAROUSEL_CHILD: 'hitId',
};

export const EDAP_FIELD_TO_CAROUSEL_FIELD_MAP = {
    [EDAP_EVENT_DATA_FIELDS.ACTIONLOCATION]: CAROUSEL_DATA_FIELDS.TARGET,
    [EDAP_EVENT_DATA_FIELDS.CAROUSEL_TITLE]: CAROUSEL_DATA_FIELDS.TITLE,
    [EDAP_EVENT_DATA_FIELDS.CHILDREN_DISPLAYED]:
        CAROUSEL_DATA_FIELDS.HITS_IN_VIEW_IDS,
    [EDAP_EVENT_DATA_FIELDS.CHILDREN_DISPLAYED_ATTRIBUTES]:
        CAROUSEL_DATA_FIELDS.HITS_IN_VIEW,
    [EDAP_EVENT_DATA_FIELDS.RECOMMENDATION_REQUEST_MARKER]:
        CAROUSEL_DATA_FIELDS.CLIENT_REQUEST_ID,
    [EDAP_EVENT_DATA_FIELDS.CARD_INDEX]: CAROUSEL_DATA_FIELDS.CARD_INDEX,
    [EDAP_EVENT_DATA_FIELDS.CAROUSEL_CHILD]:
        CAROUSEL_DATA_FIELDS.CAROUSEL_CHILD,
};

export const EVENT_SPECIFIC_ATTRIBUTES = {
    [EVENT_TYPES.PRESENTED]: [
        EDAP_EVENT_DATA_FIELDS.RECOMMENDATION_REQUEST_MARKER,
        EDAP_EVENT_DATA_FIELDS.CHILDREN_DISPLAYED_ATTRIBUTES,
        EDAP_EVENT_DATA_FIELDS.CHILDREN_DISPLAYED,
        EDAP_EVENT_DATA_FIELDS.ACTIONLOCATION,
        EDAP_EVENT_DATA_FIELDS.CAROUSEL_TITLE,
    ],
    [EVENT_TYPES.SELECTED]: [
        EDAP_EVENT_DATA_FIELDS.RECOMMENDATION_REQUEST_MARKER,
        EDAP_EVENT_DATA_FIELDS.ACTIONLOCATION,
        EDAP_EVENT_DATA_FIELDS.CARD_INDEX,
        EDAP_EVENT_DATA_FIELDS.CAROUSEL_CHILD,
    ],
    [EVENT_TYPES.UPDATED]: [
        EDAP_EVENT_DATA_FIELDS.RECOMMENDATION_REQUEST_MARKER,
        EDAP_EVENT_DATA_FIELDS.CHILDREN_DISPLAYED_ATTRIBUTES,
        EDAP_EVENT_DATA_FIELDS.CHILDREN_DISPLAYED,
    ],
};
